// <script src="{{ 'checkout-event.js' | asset_url }}" async></script>

document.addEventListener("checkout:go", async function () {
  // prevent reloading the page here
  console.log("getting the new event")
  try {
    const checkoutInfo = await fetch("/checkout");
    if (checkoutInfo.ok) {
      const url = new URL(checkoutInfo.url);
      const pathSegments = url.pathname.split("/");
      const checkoutId = pathSegments[pathSegments.length - 1];

      const note = await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                attributes: {
                    'unique_checkout_id': checkoutId
                }
            })
        });

      console.log(note)

      if (typeof a10x_dl !== "undefined") {
        a10x_dl.unique_checkout_id = checkoutId;
        session_sync(a10x_dl.s_id, "unique_checkout_id", checkoutId);
        console.log("checkoutId: ", a10x_dl.unique_checkout_id);
      }
    } else {
      // Handle HTTP error
      console.error("Error fetching checkout info:", checkoutInfo.status);
    }
  } catch (error) {
    // Handle fetch error
    console.error("Fetch error:", error.message);
  }
  // redirect to checkout page here
  // window.location.href = "/checkout";
});

document.addEventListener("rebuy:cart.add", () => {
document.dispatchEvent(new CustomEvent("checkout:go"));
})
document.dispatchEvent(new CustomEvent("checkout:go"));
